import { Component } from 'react';
import { inject } from 'mobx-react';
import propTypes from 'prop-types';
import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';
// TODO: import stencil component: pes-icon

class _ExportOption extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  handleClick = async () => {
    this.setState({ isLoading: true});
    try {
      await this.props.onExport(); 
    } catch(error) {
      console.error('Cannot download File',error);
    } finally {
      this.setState({isLoading: false});
    }
  }
  render() {
    const optionLabel = this.state.isLoading ? this.props.labelsStore.exportGenerate : this.props.label;
    const classModifier = this.state.isLoading ? 'cart-export__option--loading' : '';
    return (
      <>
        <div onClick={this.handleClick} className={`cart-export__option actions-block__row ${classModifier}`}>
          <PesIcon class="actions-block__icon" size={pesIconSizes.SMALL}>
            {this.props.useHref}
          </PesIcon>
          <span className="actions-block__cta pes-link" data-stayopen data-autotests-id={this.props.autotestsId}>
          {optionLabel}
          </span>
        </div>
      </>
    );
  }
}

_ExportOption.propTypes = {
  handleClick: propTypes.func.isRequired,
  useHref: propTypes.string.isRequired,
  label: propTypes.string.isRequired,
  labelsStore: propTypes.shape({
    exportGenerate: propTypes.string.isRequired
  }).isRequired,
  autotestsId: propTypes.string.isRequired
};

export const ExportOption = inject((allStores) => ({
  labelsStore: allStores.labelsStore
}))(_ExportOption);
